import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import RedemptionRiskEventsTable from './components/RedemptionRiskEventsTable';

const RedemptionRiskEventsIndex = () => (
    <Container className="dashboard">
        <Row>
            <Col md={12}>
                <h3 className="page-title">Redemption Risk Review</h3>
                <h3 className="page-subhead subhead">
                    <Link to="/">Home</Link> / Approvals / Redemptions
                </h3>
            </Col>
        </Row>
        <Row>
            <Col md={12}>
                <Card>
                    <CardBody>
                        <RedemptionRiskEventsTable />
                    </CardBody>
                </Card>
            </Col>
        </Row>
    </Container>
);

export default RedemptionRiskEventsIndex;
